import moment from "moment";

export const getValidationFieldClasses = function(fieldList,errors,fieldName)
{
    var classes = [];

    classes.push('fg_'+fieldName);

    if(errors.has(fieldName))
        classes.push('has-danger');

    if(fieldList[fieldName] && fieldList[fieldName].touched && fieldList[fieldName].valid)
        classes.push('has-success');

    return classes.join(" ");
}

/**
 * General sorting function for different data types.
 * @param {Array} data - Array of objects to sort.
 * @param {String} key - The key to sort by.
 * @param {String} type - Type of data (string, numeric, date).
 * @param {String} order - Sorting order ('asc' or 'desc').
 * @returns {Array} - Sorted array.
 */
export function sortData(data, key, type = "string", order = "asc") {
    return [...data].sort((a, b) => {
        let valA = a[key];
        let valB = b[key];

        if (type === "numeric" || type === "money") {
            valA = parseFloat(valA) || 0;
            valB = parseFloat(valB) || 0;
        } else if (type === "date") {
            valA = moment(valA, "DD.MM.YYYY");
            valB = moment(valB, "DD.MM.YYYY");
        } else if (type === "datetime") {
            valA = moment(valA, "DD.MM.YYYY HH:mm:ss");
            valB = moment(valB, "DD.MM.YYYY HH:mm:ss");
        } else if (type === 'order_index') {
            valA = parseFloat(a[key+"_order_index"]) || 0;
            valB = parseFloat(b[key+"_order_index"]) || 0;
        } else if (type === 'interval') {
            valA = valA.length === 0 ? '' : (key === 'shift_plan_intervals' ? valA[0]['plan_interval_type'] + valA[0]['from'] : valA[0]['work_interval_type'] + valA[0]['from']);
            valB = valB.length === 0 ? '' : (key === 'shift_plan_intervals' ? valB[0]['plan_interval_type'] + valB[0]['from']: valB[0]['work_interval_type'] + valB[0]['from']);
        } else {
            valA = valA ? String(valA).toLowerCase() : "";
            valB = valB ? String(valB).toLowerCase() : "";
        }

        let comparison = 0;
        if (type === "numeric" || type === "money" || type === 'order_index') {
            comparison = valA - valB;
        } else if(type === "date" || type === "datetime") {
            if (!valA.isValid()) comparison = -1;
            else if(!valB.isValid()) comparison = 1;
            else comparison = valA.diff(valB);
        } else {
            var collator = new Intl.Collator('sk-u-kc');
            comparison = collator.compare(valA, valB);
        }

        return order === "desc" ? -comparison : comparison;
    });
}



// WEBPACK FOOTER //
// ./resources/assets/admin/js/utils.js